export type TCardMode = 'dark' | 'light' | 'black';

export enum GameErrorType {
  NotFound = 0,
  NotAvailCurrency = 1,
  GeoBlocked = 2,
  NotAuth = 3,
}
